import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";

import OnboardingPageLayout from "../../../layouts/OnboardingPageLayout";
import TofuLayout from "@layout/TofuLayout";
import TofuLayoutWide from "@layout/TofuLayoutWide";
import ProtectRouteByFormStatus from "@routes/ProtectRouteByFormStatus";
import ProtectRouteAfterWaitingRoom from "@routes/ProtectRouteAfterWaitingRoom";
import ProtectRouteAuthenticated from "@routes/ProtectRouteAuthenticated";
import { Cotizador } from "@pages/producto/credito_simple/tofu_v2/Cotizador";
import { CrearCuenta } from "@pages/producto/credito_simple/tofu_v2/CrearCuenta";
import { RegistroDatosPersonales } from "@pages/producto/credito_simple/tofu_v2/RegistroDatosPersonales";
import { ValidacionTelefono } from "@pages/producto/credito_simple/tofu_v2/ValidacionTelefono";
import { InformacionEmpresa } from "@pages/producto/credito_simple/tofu_v2/InformacionEmpresa";
import { DecisionIngreso } from "@pages/producto/credito_simple/tofu_v2/DecisionIngreso";
import { ConexionSAT } from "@pages/producto/credito_simple/tofu_v2/ConexionSAT";
import { CargaDocumentos } from "@pages/producto/credito_simple/tofu_v2/CargaDocumentos";
import { NipBuro } from "@pages/producto/credito_simple/tofu_v2/NipBuro";
import { UsoCredito } from "@pages/producto/credito_simple/tofu_v2/UsoCredito";
import { PresenciaDigital } from "@pages/producto/credito_simple/tofu_v2/PresenciaDigital";
import { ConexionCuentas } from "@pages/producto/credito_simple/tofu_v2/ConexionCuentas";
import { UsoLinea } from "@pages/producto/credito_simple/tofu_v2/UsoLinea";
import { DatosAccionista } from "@pages/producto/credito_simple/tofu_v2/DatosAccionista";
import { DomicilioAccionista } from "@pages/producto/credito_simple/tofu_v2/DomicilioAccionista";
import { ConsultaBuro } from "@pages/producto/credito_simple/tofu_v2/ConsultaBuro";
import { AccionistaConfirmacion } from "@pages/producto/credito_simple/tofu_v2/AccionistaConfirmacion";
import { WaitingRoomConcluida } from "@pages/producto/credito_simple/tofu_v2/WaitingRoomConcluida";
// import { Resultado } from "@pages/producto/credito_simple/tofu_v2/Resultado";
import { ListaRevision } from "@pages/producto/credito_simple/expediente_v2/ListaRevision";
import { ExpDictamen } from "@pages/producto/credito_simple/expediente_v2/ExpDictamen";
import { ExpInformacionSolicitud } from "@pages/producto/credito_simple/expediente_v2/ExpInformacionSolicitud";
import { ExpInformacionBancaria } from "@pages/producto/credito_simple/expediente_v2/ExpInformacionBancaria";
import { ExpEmpresa } from "@pages/producto/credito_simple/expediente_v2/ExpEmpresa";
import { ExpReferencias } from "@pages/producto/credito_simple/expediente_v2/ExpReferencias";
import { ExpPersonas } from "@pages/producto/credito_simple/expediente_v2/ExpPersonas";
import { ExpValId } from "@pages/producto/credito_simple/expediente_v2/ExpValId";
import { ExpReview } from "@pages/producto/credito_simple/expediente_v2/ExpReview";
import { InformacionMultiGarantias } from "@pages/producto/credito_simple/tofu_v2/InformacionMultiGarantias";
import { Ofertas } from "@pages/producto/credito_simple/tofu_v2/Ofertas";
import { OfertaSeleccionada } from "@pages/producto/credito_simple/tofu_v2/OfertaSeleccionada";

// TEMP: entra directo en "crear_cuenta" para testear su diseño. Cambiar a "cotizador" para volver al flujo normal.
const EMPRESAS_INITIAL_SLUG = "crear_cuenta";

const OnboardingRouter = () => {
  const appData = useSelector((state: RootState) => state.app);

  return (
    <Routes>
      <Route path="/" element={<OnboardingPageLayout />}>
        {/* Desde la sala de espera (CSCOF) ya no se puede volver a las pantallas anteriores. */}
        <Route element={<ProtectRouteAfterWaitingRoom />}>
          <Route index element={<Navigate to={appData.process_page} />} />

          <Route path="" element={<TofuLayout size="md" />}>
            <Route index element={<Navigate to={EMPRESAS_INITIAL_SLUG} replace />} />
            <Route path="cotizador" element={<Cotizador />} />
            <Route path="crear_cuenta" element={<CrearCuenta />} />
            {/* Crea la cuenta e inicia la sesión al enviarse: antes de eso no hay sesión. */}
            <Route path="registro_datos_personales" element={<RegistroDatosPersonales />} />

            {/* Todo lo demás del tofu requiere sesión. */}
            <Route element={<ProtectRouteAuthenticated />}>
              <Route path="validacion_telefono" element={<ValidacionTelefono />} />
              <Route path="informacion_empresa" element={<InformacionEmpresa />} />
              <Route path="consulta_ciec" element={<ConexionSAT />} />
              <Route path="uso_de_credito" element={<UsoCredito />} />
              <Route path="presencia_digital" element={<PresenciaDigital />} />
              <Route path="uso_de_linea" element={<UsoLinea />} />
              <Route path="datos_accionista" element={<DatosAccionista />} />
              <Route path="domicilio_accionista" element={<DomicilioAccionista />} />
              <Route path="consulta_buro" element={<ConsultaBuro />} />
              <Route path="informacion_multigarantias" element={<InformacionMultiGarantias />} />
              <Route path="waiting_room" element={<WaitingRoomConcluida />} />
              <Route path="oferta_aceptada" element={<OfertaSeleccionada />} />
              <Route path="decision_ingreso" element={<DecisionIngreso />} />
              <Route path="carga_documentos" element={<CargaDocumentos />} />
              <Route path="nip_buro" element={<NipBuro />} />
              <Route path="conexion_cuentas" element={<ConexionCuentas />} />
              <Route path="confirmacion_accionista" element={<AccionistaConfirmacion />} />
            </Route>
          </Route>

          {/* Expediente y ofertas: requieren sesión. */}
          <Route element={<ProtectRouteAuthenticated />}>
            <Route path="" element={<TofuLayout size="lg" />}>
              <Route path="check_list" element={<ListaRevision />} />
              <Route path="docs_dictamen" element={<ExpDictamen />} />
              <Route path="docs_empresa" element={<ExpEmpresa />} />

              <Route element={<ProtectRouteByFormStatus attribute="loan_application_information_status" />}>
                <Route path="expediente_informacion_solicitud" element={<ExpInformacionSolicitud />} />
              </Route>

              <Route element={<ProtectRouteByFormStatus attribute="references_status" />}>
                <Route path="expediente_referencias" element={<ExpReferencias />} />
              </Route>

              <Route element={<ProtectRouteByFormStatus attribute="bank_information_status" />}>
                <Route path="expediente_informacion_bancaria" element={<ExpInformacionBancaria />} />
              </Route>

              <Route path="expediente_personas" element={<ExpPersonas />} />
              <Route path="expediente_validacion_identidad" element={<ExpValId />} />
              <Route path="expediente_revision" element={<ExpReview />} />
            </Route>

            {/* Pantallas que el diseño resuelve a todo lo ancho, fuera de la columna de captura. */}
            <Route path="" element={<TofuLayoutWide />}>
              <Route path="seleccionando_oferta" element={<Ofertas />} />
            </Route>
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};

export default OnboardingRouter;
